import { shouldShowSubscribeStep } from '../partials/onboarding/shared/subscribeStepComplete';
import { isRouterMerchantSeedPendingHydration } from '../partials/onboarding/shared/preFormInviteComplete';

export function useDashboardOnboardingUi({ merchant }) {
  const subscriptionRequired = !isRouterMerchantSeedPendingHydration(merchant) && shouldShowSubscribeStep(merchant);
  return { isActivationMode: subscriptionRequired };
}
